import React from 'react'
import { ContentLock, ContentUnlock } from '@fs/zion-icon'
import { Tag } from '@fs/zion-ui'
import { dataSharedPublicLabel, dataSharedPrivateLabel } from '../../commonStrings'

export default function SharedTag({ shared }) {
  return shared ? (
    <Tag Icon={ContentUnlock} text={dataSharedPublicLabel()} />
  ) : (
    <Tag Icon={ContentLock} text={dataSharedPrivateLabel()} />
  )
}
